import type { ApolloClient } from '@apollo/client';

import { cache, cachePersistor } from './cache';

export async function clearApolloSessionCache() {
  await cachePersistor.purge();
  await cache.reset();
}

export async function resetApolloSessionCache<TCacheShape>(client: ApolloClient<TCacheShape>) {
  await clearApolloSessionCache();
  await client.resetStore();
}
